import Button from "../components/Button/Button";

function FeedbackSection() {
  return (
    <section className=" bg-white text-center">
      <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">
        Effortless increase 5-star reviews
      </h2>

      <p className="max-w-3xl mx-auto text-gray-600 text-lg mt-4">
        You can collect customer reviews for your business on platforms like
        Google Reviews, Trustpilot, and Yelp to enhance credibility and attract
        more customers.
      </p>

      <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
        <Button variant="secondary" calendly>Book a demo</Button>
        <Button variant="primary">Get started</Button>
      </div>

      {/* Image */}
      <div className="mt-12">
        <img
          // src={feedbackImage}
          src="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f51385fc530ba6c4da62b5_Frame%204%20(4).png"
          alt="Analytics Dashboard"
          className="w-full max-w-7xl mx-auto rounded-2xl shadow-lg"
        />
      </div>
    </section>
  );
}

export default FeedbackSection;
